<template>
  <nav class="nav" :class="{ 'nav-scrolled': hasScrolled }">
    <div class="nav-container">
      <div class="logo-container">
        <img src="../assets/images/Bizz.png" alt="Bizzanto Logo" class="logo" />
      </div>

      <div class="nav-actions">
        <a href="#waitlist" class="nav-cta">Join the Waitlist</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  // Changed to multi-word to satisfy ESLint "vue/multi-word-component-names"
  name: 'AppNavbar',
  data() {
    return {
      hasScrolled: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.hasScrolled = window.scrollY > 20;
    },
  },
};
</script>

<style scoped>
.nav {
  --bg-warm-base: #f2eee0;
  --dark-accent: #1a1a1a;
  --nav-height: 100px;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: var(--nav-height);
  display: flex;
  align-items: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  /* Initial state: Transparent or subtle blend */
  background: rgba(242, 238, 224, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.nav-scrolled {
  height: 80px;
  background: rgba(242, 238, 224, 0.95);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.nav-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.logo {
  height: auto;
  width: 150px;
  max-height: 114px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.03);
}

/* Button Alignment & Style */
.nav-actions {
  display: flex;
  align-items: center;
}

.nav-cta {
  background: var(--dark-accent);
  color: white;
  padding: 14px 28px;
  border-radius: 50px; /* Pill shape matches your screenshot */
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: -0.01em;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.nav-cta:hover {
  background: #333;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .nav {
    height: 80px;
  }

  .nav-scrolled {
    height: 70px;
  }

  .logo {
    width: 120px; /* Slightly smaller but still readable on mobile */
  }

  .nav-cta {
    padding: 10px 20px;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .nav-container {
    padding: 0 16px;
  }

  .logo {
    width: 100px;
  }
}
</style>
